/**
 * @module validation/email
 */

const emailValidationRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/**
 * Validate Email string
 *
 * Be aware that this function can miss some edge cases.
 *
 * @param {String} email
 * @returns {Boolean}
 */
export function validateEmail(email) {
    return emailValidationRegexp.test(String(email).toLowerCase());
}
